import salesColumnUrl from './salesTableColumn.html';

class SalesTableColumnCtrl {
  constructor(SalesService, Utils, $scope) {
    'ngInject';

    Object.assign(this, { SalesService, Utils, $scope });
  }

  eval = (exp) => this.Utils.evaluateExpression(exp, {});

  getDeltaClass(value, isReversed) {
    if (!value) {
      return;
    }

    return (value > 0 && !isReversed) || (value < 0 && isReversed)
      ? 'color-brand-success'
      : 'color-brand-danger';
  }

  get numbers() {
    return this.$scope.data;
  }

  async saveProjectedSales(sale) {
    const updatedSale = await this._saveSale(sale);

    this.$scope.data.projectedSales = updatedSale;
    return updatedSale;
  }

  async saveActualSales(sale) {
    const updatedSale = await this._saveSale(sale);

    this.$scope.data.actualSales = updatedSale;
    return updatedSale;
  }

  async _saveSale(sale) {
    const { locationId, date } = this.$scope.data;
    const saleToSave = { ...sale };
    saleToSave.locationId = locationId;
    saleToSave.date = date;

    const updatedSale = await this.SalesService.saveSingleSale(saleToSave);
    if (!('amount' in updatedSale)) {
      updatedSale.amount = '0.00';
    }

    this.$scope.onSalesUpdate({ sale: updatedSale });
    return updatedSale;
  }

  canEditSales(sales) {
    return this.SalesService.canEditGroup(sales.location);
  }
}

export default function reportTableColumn() {
  return {
    templateUrl: salesColumnUrl,
    scope: {
      data: '<',
      type: '<',
      schema: '<',
      isTotals: '<',
      onSalesUpdate: '&',
    },
    controller: SalesTableColumnCtrl,
    controllerAs: 'ctrl',
  };
}
